/* global VueRouter */
import { ref, watch, reactive, onMounted } from "vue"
import { useAuth } from "./useAuth"
import { listPagedEntitesAsync } from "../api"
import { usePaging } from "../components/usePaging"
import { EMPTY_GUID } from "../utils/constants"

export const useOffers = () => {
  const { fetchAuthAsync } = useAuth()
  const offers = ref([])
  const router = VueRouter.useRouter()
  const route = VueRouter.useRoute()

  const getOffersAsync = async () => {
    let filter = ""
    if (filters.customer && filters.customer !== EMPTY_GUID) filter += `&customerId=${filters.customer}`
    if (filters.facility && filters.facility !== EMPTY_GUID) filter += `&facilityId=${filters.facility}`
    if (filters.offerNumber) filter += `&offerNumber=${encodeURIComponent(filters.offerNumber)}`

    const result = await listPagedEntitesAsync(
      fetchAuthAsync,
      "Offers", // Matches Route "Offers/{status}"
      paging.value,
      filters.status || "all",
      filter,
    )

    if (result) {
      if (result.entities) offers.value = result.entities
      if (typeof result.numberOfRecords === "number") setNumberOfRecords(result.numberOfRecords)
    }
  }

  const { paging, resetPaging, setPageNum, setNumberOfRecords } = usePaging(getOffersAsync)

  // Initialize filters from query
  const filters = reactive({
    status: route.query.status || "all",
    customer: route.query.customer || EMPTY_GUID,
    facility: route.query.facility || EMPTY_GUID,
    offerNumber: route.query.offerNumber || "",
  })

  watch(
    () => ({ ...filters }),
    (newFilters) => {
      const query = { ...route.query }

      if (newFilters.status && newFilters.status !== "all") query.status = newFilters.status
      else delete query.status

      if (newFilters.customer && newFilters.customer !== EMPTY_GUID) query.customer = newFilters.customer
      else delete query.customer

      if (newFilters.facility && newFilters.facility !== EMPTY_GUID) query.facility = newFilters.facility
      else delete query.facility

      if (newFilters.offerNumber) query.offerNumber = newFilters.offerNumber
      else delete query.offerNumber

      // Update URL without reloading
      router.replace({ query }).catch(() => {})

      resetPaging()
    },
  )

  onMounted(() => {
    // Trigger initial load
    // If filters are present, we want to load.
    // resetPaging() sets dirty, which triggers usePaging watcher -> getOffersAsync.
    resetPaging()
  })

  return {
    paging,
    filters,
    setPageNum,
    resetPaging,
    offers,
    getOffersAsync,
  }
}
